<template>
  <div class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
    <div class="flex justify-around mb-6">
      <div
        class="flex items-center cursor-pointer font-bold hover:text-blue-800"
        :class="sortedBy === 'date' ? 'text-blue-800' : 'text-gray-600'"
        @click="sortingStories('date')"
      >
        <icon class="mr-2" name="swap" width="17" height="17"></icon>
        <span>Сначала новые</span>
      </div>
      <div
        class="flex items-center cursor-pointer font-bold hover:text-blue-800"
        :class="sortedBy === 'rating' ? 'text-blue-800' : 'text-gray-600'"
        @click="sortingStories('rating')"
      >
        <icon class="mr-2" name="swap" width="17" height="17"></icon>
        <span>По рейтингу</span>
      </div>
    </div>
    <div v-if="loading && !isModalOpen" class="flex flex-grow items-center justify-center mt-6">
      <Loader />
    </div>
    <div
      class="flex justify-between items-center my-2 py-1 sm:py-2 px-2 sm:px-4 cursor-pointer hover:text-blue-800 shadow"
      v-for="story in stories"
      :key="story.uuid"
      @click="openModal(story.uuid, story.name)"
    >
      <span class="text-xl sm:text-2xl font-bold">{{ story.name }}</span>
      <Rating :rating="story.content.rating" />
    </div>
  </div>
</template>

<script>
import Rating from "@/components/Rating.vue";
import Loader from "@/components/Loader.vue";
import {token, storyapi} from "@/api"

export default {
  name: "Summaries",
  components: {
    Rating,
    Loader,
  },
  data() {
    return {
      stories: [],
    };
  },
  computed: {
    sortedBy() {
      return this.$store.state.sortedBy;
    },
    loading() {
      return this.$store.state.loading;
    },
    isModalOpen() {
      return this.$store.state.isModalOpen;
    }
  },
  created() {
    // Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token,
    });
    window.storyblok.on("change", () => {
      this.getStories("draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getStories("draft");
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getStories("published");
      }
    });
  },
  methods: {
    getStories(version) {
      this.$store.commit("setVersion", { name: version });
      this.$store.commit("toggleLoading");
      storyapi
        .get("cdn/stories", {
          starts_with: "sites/",
          version: version,
        })
        .then((response) => {
          this.stories = response.data.stories;
          this.sortingStories(this.$store.state.sortedBy);
          this.$store.commit("toggleLoading");
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("toggleLoading");
        });
    },
    sortingStories(param) {
      if (param === "date") {
        this.stories.sort(function (a, b) {
          if (a.created_at < b.created_at) {
            return 1;
          }
          if (a.created_at > b.created_at) {
            return -1;
          }
          return 0;
        });
        this.$store.commit("setSorted", { name: "date" });
      }
      if (param === "rating") {
        this.stories.sort(function (a, b) {
          if (a.content.rating < b.content.rating) {
            return 1;
          }
          if (a.content.rating > b.content.rating) {
            return -1;
          }
          // a должно быть равным b
          return 0;
        });
        this.$store.commit("setSorted", { name: "rating" });
      }
    },
    openModal(uid, name) {
      this.$store.commit("toggleModal", {
        site: { id: uid, title: name },
      });
    },
  },
  beforeDestroy() {
    this.$store.commit("closeModals");
  },
};
</script>
